__turbopack_context__.v({
  "image": "index-module-scss-module__XRQkMW__image",
});
